import { createRoot } from 'react-dom/client';
import App from './App';
import './index.css';

function init() {
  const container = document.getElementById('root');

  if (!container) {
    console.error("Critical: #root element not found in HTML");
  } else {
    try {
      console.log("Mounting application...");
      const root = createRoot(container);
      root.render(<App />);
      console.log("Application rendered.");
    } catch (error) {
      console.error("Critical mount error:", error);
      container.innerHTML = `<div style="padding: 20px; font-family: sans-serif; text-align: center; direction: rtl;">
        <h2 style="color: #ef4444;">שגיאת טעינה</h2>
        <pre style="text-align: left; direction: ltr; font-size: 11px; background: #f1f5f9; padding: 10px; border-radius: 8px;">${error instanceof Error ? error.stack || error.message : String(error)}</pre>
        <button onclick="window.location.reload()">נסה שוב</button>
      </div>`;
    }
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init);
} else {
  init();
}



